import { computed, signal } from '@preact/signals';
import { diaIso } from './format';
import type { Camada, Usuario } from './types';

// ---- sessão ----
export const usuario = signal<Usuario | null>(null);
/** Verdadeiro quando o app de coleta abriu sem internet e segue com o último pesquisador deste aparelho (sem acesso à API até reconectar). */
export const modoOffline = signal(false);
/** Durante uma inspeção ("ver como"): o administrador de verdade, guardado para voltar a ele. Nulo fora da inspeção. */
export const adminReal = signal<Usuario | null>(null);
/** Falso até a tentativa inicial de reaproveitar a sessão (cookie de refresh) terminar. */
export const sessaoPronta = signal(false);

// ---- filtros do painel ----
export const camada = signal<Camada>('progresso');
/** 0 = ao vivo; N = estado de N dias atrás. */
export const diasAtras = signal(0);
export const secretariaId = signal('');
export const pesquisaId = signal('');
export const municipioSel = signal<string | null>(null);
/** Camada "Indicadores oficiais": eixo e indicador escolhidos. */
export const eixoSel = signal('educacao');
export const indicadorSel = signal('');

/** Data histórica pedida à API (undefined = ao vivo). */
export const dataSel = computed(() => (diasAtras.value === 0 ? undefined : diaIso(diasAtras.value)));

export const MAX_DIAS_ATRAS = 90;
